<template>
	<div class="tw-w-screen tw-h-screen tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4">
		<BaseLoader class="tw-w-16 tw-h-16" />
		<p class="tw-bold tw-text-grey-dark">
			{{ $t('logging_out') }}
		</p>
	</div>
</template>

<script>
import { logout } from "@/services/root.js";
import BaseLoader from "@/components/elements/BaseLoader.vue";

export default {
	components: {
		BaseLoader,
	},
	async created() {
		await logout();
	},
};
</script>
